import { Outlet } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { FixtureTabLayout } from '#src/layouts/FixtureLayout/FixtureTabLayout/index.tsx';

const CareerBoardLayout = () => {
  return (
    <FixtureTabLayout
      eventType={So5FixtureEvent.CLASSIC}
      so5FixtureSlug="ongoing"
    >
      <Outlet />
    </FixtureTabLayout>
  );
};

export default CareerBoardLayout;
